<template>
  <AppMessage
    v-if="!isClosed"
    variant="warning"
    @close="isClosed = true">
    <p class="font-bold">
      {{ t('integrations.bol.expiresSoon.title') }}
    </p>
    <Translation keypath="integrations.bol.expiresSoon.description">
      <template #shop>
        <strong>{{ currentShop.name }}</strong>
      </template>
      <template #date>
        <strong>{{ localizedDateFormat(credentials.expires, 'D MMMM YYYY') }}</strong>
      </template>
    </Translation>
    <ol class="list-decimal me-4 ms-4">
      <li>
        <Translation keypath="integrations.bol.step1.description">
          <template #link>
            <RouterLink
              class="text-secondary"
              :to="{
                name: 'shop-settings-integration',
                params: {
                  shopId: currentShop.id,
                },
              }">
              {{ t('integrations.bol.step1.link.label') }}
            </RouterLink>
          </template>
        </Translation>
      </li>
      <li>{{ t('integrations.bol.step2') }}</li>
      <li>{{ t('integrations.bol.step3') }}</li>
    </ol>
  </AppMessage>
</template>

<script setup lang="ts">
import type {ExternalProvider} from '@myparcel-frontend/types';
import {ref} from 'vue';
import {Translation, useI18n} from 'vue-i18n';
import {RouterLink} from 'vue-router';
import AppMessage from '@/components/ui/AppMessages/AppMessage.vue';
import useShop from '@/composables/useShop/useShop';
import {localizedDateFormat} from '@/utils/dateTime';

const {t} = useI18n();
const {currentShop} = useShop();

const isClosed = ref(false);

defineProps<{
  credentials: ExternalProvider;
}>();
</script>
